export default {
  getRoles: state => state.roles,
}
